export const ADVANCED_SETTINGS_KEY = 'n23j4o3i2j4o2i34';
